$(function() {
    const $contactUsPopupBtn = $('#contact-us-popup-btn'),
        $contactUsPopupWrapper = $('#contact-us-popup-wrapper'),
        $contactUsPopupForm = $('#contact-us-popup-form'),
        $openMessage = $contactUsPopupWrapper.find('.open-message'),
        $mainButton = $contactUsPopupWrapper.find('button'),
        states = [
            {
                'name': 'openMessage',
                'buttonText': hpaTranslatedtext.contactUsPopupForm.openMessage.buttonText, // 'Send Us A Message'
                'class': 'state-openMessage',
                'bubble': {
                    'status': 0,
                }
            },
            {
                'name': 'form',
                'buttonText': hpaTranslatedtext.contactUsPopupForm.form.buttonText, // 'Send Message'
                'class': 'state-form',
                'bubble': {
                    'status': 1,
                    'message': hpaTranslatedtext.contactUsPopupForm.form.bubble.message, // 'Hey, how can we help?'
                    'signed': '- Taz',
                },
            },
            {
                'name': 'success',
                'buttonText': hpaTranslatedtext.contactUsPopupForm.success.buttonText, // 'Message Sent'
                'class': 'state-success',
                'bubble': {
                    'status': 1,
                    'message': hpaTranslatedtext.contactUsPopupForm.success.bubble.message, // 'Got it, I\'ll reply as soon as possible!'
                    'signed': '- Taz',
                },
            }
        ];

    if (!$contactUsPopupWrapper.length) return false;

    let currentState = $contactUsPopupWrapper.data('state');
    // console.log('currentState:', currentState);

    $mainButton.on('click', function() {
        const $this = $(this),
            buttonDisabled = $this.attr('data-disabled'); // using attr instead of data so that the css works

        // console.log({
        //     currentState,
        //     buttonDisabled,
        // });

        if (buttonDisabled === 'true') return false;

        if (currentState === 'openMessage') {
            currentState = 'form';
            $contactUsPopupWrapper.data('state', currentState).removeClass().addClass('state-' + currentState);

            const stateData = states.find(state => state.name === currentState);
            $mainButton.text(stateData.buttonText);
        } else if (currentState === 'form') {
            $contactUsPopupForm[0].requestSubmit();
        } else if (currentState === 'success') {

        }

        // console.log('newState', $contactUsPopupWrapper.data('state'));

        bubbleToggle();
    });

    $contactUsPopupBtn.on('click', function() {
        const $this = $(this),
            $svgOpen = $this.find('.svg-contact-popup-icon-open'),
            $svgClose = $this.find('.svg-contact-popup-icon-close');

        $svgOpen.toggle();
        $svgClose.toggle();

        $contactUsPopupWrapper.slideToggle('fast');
    });

    $contactUsPopupForm.on('submit', function(e) {
        e.preventDefault();

        const $this = $(this),
            formData = $this.serialize(),
            url = $this.attr('action'),
            $messageField = $contactUsPopupWrapper.find('.alert'),
            submitBtnProcessingText = 'Sending...';

        $messageField.html('').removeClass('alert-danger').removeClass('alert-success').hide();

        $mainButton.attr('data-disabled', 'true'); // using attr instead of data so that the css works
        $mainButton.text(submitBtnProcessingText);

        $.ajax({
          type: 'POST',
          url: url,
          data: formData,
          dataType: 'json',
        }).done(function (data) {
            // console.log(data);
            let status = 0,
                message = '';

            if ($.isArray(data)) {
                for (var n = 0, m = data.length; n < m; n++) {
                    if ('message' in data[n]) {
                        if (message !== '') message += '<br>';
                        message += data[n].message;
                    }
                }
            } else {
                status = data.status;
                if (data.message !== '') {
                    message += data.message;
                }

                if (status === 1) {
                    $this.find('input[type=text], input[type=email], textarea').val('');
                    currentState = 'success';
                }
            }

            if (status === 0 && message !== '') {
                $messageField.html(message).addClass('alert-' + (status === 1 ? 'success' : 'danger')).show();
                $mainButton.attr('data-disabled', 'false'); // using attr instead of data so that the css works
            }

            const stateData = states.find(state => state.name === currentState);

            $contactUsPopupWrapper.data('state', currentState).removeClass().addClass('state-' + currentState);
            $mainButton.text(stateData.buttonText);
            bubbleToggle();
        });
    });

    const bubbleToggle = function() {
        const stateData = states.find(state => state.name === currentState),
            $bubble = $contactUsPopupWrapper.find('.bubble'),
            $bubbleMessage = $bubble.find('.bubble__content__message'),
            $bubbleSigned = $bubble.find('.bubble__content__signed'),
            $bubbleSpacer = $contactUsPopupWrapper.find('.bubble-spacer');
        // console.log('bubbleToggle', stateData);
        if (stateData.bubble.status === 1) {
            $bubble.show();
            $bubbleSpacer.show();
            $bubbleMessage.html(stateData.bubble.message);
            $bubbleSigned.text(stateData.bubble.signed);
        } else {
            $bubble.hide();
            $bubbleSpacer.hide();
        }
    };

    bubbleToggle();
});



// WEBPACK FOOTER //
// ./js/modules/contactUsPopupForm.js